<template>
  <main>
    <form class="md-layout md-alignment-center" method="post" @submit.prevent="formValidate">
      <md-card class="md-layout-item md-size-40 md-xsmall-size-100 md-alignment-center">
        <md-card-header>
          <div class="md-gutter md-layout md-alignment-center">
            <img src="https://cdn.jon-api.com/shikaku-map/img/logo.png">
          </div>
          <div class="md-gutter md-layout md-alignment-center">
            <span class="md-title">シカクマップ請求管理</span>
          </div>
        </md-card-header>

        <md-card-content class="md-layout-item md-layout md-alignment-center">
          <flash-message class="md-layout-item md-size-60 md-small-size-100" v-if="errorMessages.length"
                         :errors="errorMessages"></flash-message>
          <md-field class="md-layout-item md-size-60 md-small-size-100" :class="getValidationClass('username')">
            <label>ユーザー名</label>
            <md-input name="username" v-model="form.username" required autofocus :disabled="sending"/>
            <validation-error v-if="getValidationResponseMessage('username')"
                              :error="getValidationResponseMessage('username')"></validation-error>
            <validation-error :error="errors.username.required"
                              v-else-if="!$v.form.username.required"></validation-error>
            <validation-error :error="errors.username.loginId"
                              v-else-if="!$v.form.username.loginId"></validation-error>
          </md-field>
          <md-field class="md-layout-item md-size-60 md-small-size-100" :class="getValidationClass('password')">
            <label>パスワード</label>
            <md-input type="password" name="password" v-model="form.password" required :disabled="sending"/>
            <validation-error v-if="getValidationResponseMessage('password')"
                              :error="getValidationResponseMessage('password')"></validation-error>
            <validation-error :error="errors.password.required"
                              v-else-if="!$v.form.password.required"></validation-error>
            <validation-error :error="errors.password.password"
                              v-else-if="!$v.form.password.password"></validation-error>
          </md-field>
        </md-card-content>

        <md-card-actions class="md-layout md-alignment-center">
          <md-button :disabled="sending" class="md-primary md-raised" type="submit">
            <md-icon>exit_to_app</md-icon>
            <span>ログイン</span>
          </md-button>
        </md-card-actions>
      </md-card>
    </form>
  </main>
</template>

<script>
  import FlashMessage                      from "../../../components/FlashMessage";
  import ValidationError                   from "../../../components/ValidationError";
  import Validation                        from "../../../modules/validation";
  import {apiClient, apiList}              from '../../../modules/apiClient';
  import {validationMixin}                 from 'vuelidate'
  import {required, maxLength, minLength,} from 'vuelidate/lib/validators';
  import Common                            from "../../../modules/common";
  import CommonMixin                       from "../../../mixins/commonMixin";

  export default {
    components: {ValidationError, FlashMessage},
    mixins    : [validationMixin, CommonMixin],
    data      : () => ({
      form    : {
        username: null,
        password: null,
      },
      response: '',
      errors  : {
        username: {
          required: Validation.errorMessage(Validation.rules.required, 'username'),
          loginId : Validation.errorMessage(Validation.rules.loginId, 'username'),
        },
        password: {
          required: Validation.errorMessage(Validation.rules.required, 'password'),
          password: Validation.errorMessage(Validation.rules.password, 'password'),
        }
      },
    }),
    validations() {
      return {
        form: {
          username: {
            required,
            loginId: Validation.loginId,
          },
          password: {
            required,
            password: Validation.password,
          },
        }
      };
    },
    mounted   : function () {
      const errorForceLogin = localStorage.getItem(Common.localStorageKeys.admin.errorForceLogin);
      if (errorForceLogin !== null) {
        this.errorMessages = [errorForceLogin];
        localStorage.removeItem(Common.localStorageKeys.admin.errorForceLogin);
      }
    },
    methods   : {
      formValidate() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.onSubmit();
        }
      },
      onSubmit() {
        this.sending = true;
        apiClient.post(apiList.manager.login, this.form)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            localStorage.setItem(Common.localStorageKeys.admin.accessToken, response.data.access_token);
            localStorage.setItem(Common.localStorageKeys.admin.accessTokenExpireIn, response.data.expires_in);
            // Get redirectTo
            let redirectTo = localStorage.getItem(Common.localStorageKeys.redirectToAdmin);
            if (redirectTo !== null) {
              localStorage.removeItem(Common.localStorageKeys.redirectToAdmin);
              this.$router.replace(redirectTo);
              return;
            }
            redirectTo = localStorage.getItem(Common.localStorageKeys.admin.redirectAfterMaintenance);
            if (redirectTo !== null) {
              localStorage.removeItem(Common.localStorageKeys.admin.redirectAfterMaintenance);
              this.$router.replace(redirectTo);
              return;
            }
            this.$router.replace({name: 'BackendAdminBillings'});
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
          });
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "src/assets/scss/components.scss";

  form {
    height: 100vh;
  }

  .md-button .md-button-content label {
    display: inline;
    height: 100%;
    vertical-align: middle;
    padding: 0 5px;
  }
</style>
